module.exports = __webpack_public_path__ + "images/stickers/warning.8df25e4231fe31d88751.png";